import { axiosInstance } from "@src/api/axiosConfig";
import { axiosPath } from "@src/api/axiosPath";
import { CorpDeungiListResponseDto } from "../dto/DeungiList.dto";

// 법인 등기 발급 상태 확인
// 1: 대기중 2: 주소검색 중 3: 주소검색 실패 4: 결제진행 중 5: 결제실패 6: PDF발급 중 7: PDF발급 실패 8: 완료 9: 에러(발급불가능한 경우)
export const useCorpDeungiInfo = async (id: string) => {
    const response = await axiosInstance.get(`${axiosPath.submitCorpDeungi}/${id}/issue-status`);
    return response;
};

// 법인 등기 pdf 발급용
export const useGetCorpDeungiPdf = async (id: string) => {
    const response = await axiosInstance.get(`${axiosPath.submitCorpDeungi}/${id}/pdf`, {
        responseType: "blob",
    });
    return response?.data;
};

// 특정 id 법인 등기 정보
export const useGetCorpDeungiInfo = async (id: string) => {
    const response = await axiosInstance.get<CorpDeungiListResponseDto>(`${axiosPath.submitCorpDeungi}/${id}`);
    return response?.data;
};
